import { useState } from 'react';

import PromptModal from '../components/modals/PromptModal';

function usePromptModal(props) {
    const [isOpen, setIsOpen] = useState(props?.isOpen);

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    const close = () => {
        setIsOpen(false);
    };

    const canProcess = prompt => {
        if (prompt.isProcessing) {
            return false;
        }
        prompt.setProcessing(true);
        return true;
    };

    const render = renderProps => {
        return <PromptModal isOpen={isOpen} onClose={toggle} {...renderProps} />;
    };

    return {
        isOpen,
        setIsOpen,
        toggle,
        close,
        render,
        canProcess
    };
}

export default usePromptModal;
